export function clearCopiedSuperbill(clone: any): void {
  if (!clone) {
    return;
  }
  clone.superbillRequested = false;
  clone.superbill = null;
}
